import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DetalleProveedoresComponent } from '../../detalle-proveedores/detalle-proveedores.component';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DialogInformationComponent } from 'src/app/shared/components/dialog-information/dialog-information.component';
import { Constanst } from 'src/app/core/constants/constans.component';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-detalle-materiales',
  templateUrl: './detalle-materiales.component.html',
  styleUrls: ['./detalle-materiales.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class DetalleMaterialesComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  materialForm: FormGroup;

  nroRegistros: number = this.data.nroRegistro;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  supplierExists: boolean = false;
  national: boolean;
  urlImage: string = '';
  urlPDF: string = '';
  statusPdf: boolean = true;
  specification: string = '';
  statusSpecification: boolean = true;
  description: string = '';
  reference: string = '';
  botonPdf: boolean = this.data.simple;
  dialogTitle: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogDetalleProveedor: MatDialog,
    private apiCallService: ApiCallService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    public dialogSpecification: MatDialog,
    public dialogDetalleMaterialRef: MatDialogRef<DetalleMaterialesComponent>,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit(): void {
    this.dialogTitle = this.data.dialogTitle;
    this.consultMaterialDetails();

    this.materialForm = new FormGroup ({
      reference: new FormControl({value: '', disabled: true}),
      unitEntity: new FormControl({value: '', disabled: true}),
      date: new FormControl({value: '', disabled: true}),
      description: new FormControl({value: '', disabled: true}),
      precio: new FormControl({value: '', disabled: true}),
      waste: new FormControl({value: '', disabled: true}),
      commentary: new FormControl({value: '', disabled: true}),
      materialFamilyEntity: new FormControl({value: '', disabled: true}),
      materialGroupingEntity: new FormControl({value: '', disabled: true}),
      precioEnDolares: new FormControl({value: '', disabled: true}),
      relateDollar: new FormControl({value: false, disabled: true}),
      isNational: new FormControl ({value:'', disabled: true}),
      van: new FormControl({value: '', disabled: true}),
      bringsVan: new FormControl({value: false, disabled: true}),
      imageUrl: new FormControl({value: '', disabled: true}),
      proveedor: new FormGroup ({
        referencia: new FormControl({value: '', disabled: true}),
        razonSocial: new FormControl({value: '', disabled: true}),
        contacto: new FormControl({value: '', disabled: true}),
        actividad: new FormControl({value: '', disabled: true}),
        especialidad: new FormControl({value: '', disabled: true}),
        direccion1: new FormControl({value: '', disabled: true}),
        direccion2: new FormControl({value: '', disabled: true}),
        telefono: new FormControl({value: '', disabled: true}),
        fax: new FormControl({value: '', disabled: true}),
        email: new FormControl({value: '', disabled: true}),
        web: new FormControl({value: '', disabled: true}),
        comentario: new FormControl({value: '', disabled: true}),
      })
    });
  }

  openProviderDetails(provider: any) {
    const dialog = this.dialogDetalleProveedor.open(DetalleProveedoresComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      // disableClose: true,
      data: {provider}
    });
  }

  consultMaterialDetails() {
    this.route = '/getMaterialDetailById';
    this.method = 'POST';

    let data = {
      idMaterial: this.data.row.id,
      idMaterialZone: this.data.row.idMaterialZone
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
    .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        //console.log(response);
        if (response.data.materialZoneEntity.supplierEntity) {
          this.supplierExists = true;
        }
        this.materialForm = new FormGroup ({
          reference: new FormControl({value: response.data.materialEntity.reference, disabled: true}),
          unitEntity: new FormControl({value: response.data.materialEntity.unitEntity.description, disabled: true}),
          date: new FormControl({value: this.datePipe.transform(response.data.materialEntity.date, 'dd/MM/yyyy'), disabled: true}),
          description: new FormControl({value: response.data.materialEntity.description, disabled: true}),
          precio: new FormControl({value: this.decimalPipe.transform(response.data.materialZoneEntity.price, '1.2-2'), disabled: true}),
          waste: new FormControl({value: this.decimalPipe.transform(this.data.row.waste, '1.2-2'), disabled: true}),
          commentary: new FormControl({value: this.data.row.commentary, disabled: true}),
          materialFamilyEntity: new FormControl({value: response.data.materialEntity.materialFamilyEntity ? response.data.materialEntity.materialFamilyEntity.description : '', disabled: true}),
          materialGroupingEntity: new FormControl({value: response.data.materialEntity.materialGroupingEntity ? response.data.materialEntity.materialGroupingEntity.group : '', disabled: true}),
          precioEnDolares: new FormControl({value: this.decimalPipe.transform(response.data.materialEntity.dollarPrice, '1.2-2'), disabled: true}),
          relateDollar: new FormControl({value: response.data.materialEntity.relateDollar, disabled: true}),
          isNational: new FormControl({value: response.data.materialEntity.national === true ? 'nacional' : 'importado', disabled: true}),
          van: new FormControl({value: this.decimalPipe.transform(response.data.materialEntity.addedValue, '1.2-2'), disabled: true}),
          bringsVan: new FormControl({value: response.data.materialEntity.bringsVan, disabled: true}),
          imageUrl: new FormControl({value: response.data.materialEntity.imageUrl, disabled: true}),
          proveedor: new FormGroup ({
            referencia: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.supplierCode : '', disabled: true}),
            razonSocial: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.supplierName : '', disabled: true}),
            contacto: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.contact : '', disabled: true}),
            actividad: new FormControl({ value: response.data.materialZoneEntity.supplierEntity && response.data.materialZoneEntity.supplierEntity.activityEntity ?
              response.data.materialZoneEntity.supplierEntity.activityEntity.activityName : '', disabled: true }),
            especialidad: new FormControl({ value: response.data.materialZoneEntity.supplierEntity && response.data.materialZoneEntity.supplierEntity.specialtyEntity ?
              response.data.materialZoneEntity.supplierEntity.specialtyEntity.specialtyName : '', disabled: true }),
            direccion1: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.address1 : '', disabled: true}),
            direccion2: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.address2 : '', disabled: true}),
            telefono: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.phone : '', disabled: true}),
            fax: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.fax : '', disabled: true}),
            email: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.email : '', disabled: true}),
            web: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.web : '', disabled: true}),
            comentario: new FormControl({value: response.data.materialZoneEntity.supplierEntity ? response.data.materialZoneEntity.supplierEntity.commentary : '', disabled: true}),
          })
        });
        this.urlImage = response.data.materialEntity.imageUrl ? response.data.materialEntity.imageUrl : Constanst.IMG_MATERIAL_NOT_AVAILABLE;
        if (response.data.materialEntity.pdfUrl) {
          this.urlPDF = response.data.materialEntity.pdfUrl;
          this.statusPdf = false;
        }
        if (response.data.materialEntity.specification) {
          this.specification = response.data.materialEntity.specification;
          this.statusSpecification = false;
        }
        this.description = response.data.materialEntity.description;
        this.reference = response.data.materialEntity.reference;
        this.apiCallService.hideSpinner();
      }
    );

  }

  openPDF(fileUrl: string) {
    this.helperClassService.validateDocumentExists(fileUrl).subscribe(existe => {
      if (existe) {
        window.open(fileUrl, '_blank');
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_DOCUMENT_NOT_AVAILABLE, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    });
  }

  openSpecification(specification: string) {
    this.dialogSpecification.open(DialogInformationComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      data: {specification, reference: this.reference, description: this.description}
    });
  }

  closeDialogDetalleMaterial() {
    this.dialogDetalleMaterialRef.close();
  }

}
